import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './css/loadingScreen.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import LoadingScreen from './pages/loadingScreen';
import { HelmetProvider } from 'react-helmet-async';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingScreen />}>

    <Router>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Router>
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
